import type { Component, ExtractPropTypes, PropType, StyleValue } from 'vue'
import type _TypeTree from './type-tree.vue'

export type TreeNodeData = Record<string, any>

export declare type TreeData = TreeNodeData[]
export declare type TreeKey  = string | number

export declare interface TreeOptionProps {
    children?: string
    label?: string | ((data: TreeNodeData, node: any) => string)
    disabled?: string | ((data: TreeNodeData, node: any) => string)
    isLeaf?: string | ((data: TreeNodeData, node: any) => boolean)
    class?: (
        data: TreeNodeData,
        node: any
    ) => string | Record<string, boolean> | string
}

export declare type LoadFunction = (
    rootNode: any,
    loadedCallback: (data: TreeData) => void
) => void

export declare type FilterValue = any
export declare type FilterNodeMethodFunction = (
    value: FilterValue,
    data: TreeNodeData,
    child: any
) => boolean

export const sdTypeTreeProps = {
    data                : { type: Array,  default: () => [] },
    emptyText           : { type: String  },
    renderAfterExpand   : { type: Boolean, default: true  },
    checkStrictly       : Boolean,
    defaultExpandAll    : Boolean,
    expandOnClickNode   : { type: Boolean, default: true  },
    checkOnClickNode    : Boolean,
    checkDescendants    : { type: Boolean, default: false },
    autoExpandParent    : { type: Boolean, default: true },
    defaultCheckedKeys  : Array as PropType<TreeKey[]>,
    defaultExpandedKeys : Array as PropType<TreeKey[]>,
    currentNodeKey      : [String, Number] as PropType<string | number>,
    renderContent       : Function,
    showCheckbox        : { type: Boolean, default: false },
    draggable           : { type: Boolean, default: false },
    allowDrag           : Function,
    allowDrop           : Function,
    props: {
        type: Object as PropType<TreeOptionProps>,
        default: () => ({
            children: 'children',
            label   : 'label',
            disabled: 'disabled',
        }),
    },
    lazy            : { type: Boolean,  default: false  },
    highlightCurrent: Boolean,
    load            : Function as PropType<LoadFunction>,
    filterNodeMethod: Function as PropType<FilterNodeMethodFunction>,
    indent          : { type: Number, default: 18 },
    icon            : [String, Object] as PropType<string | Component>,

    // 覆盖属性
    accordion       : { type: Boolean, default: true                                    }, // 手风琴模式
    nodeKey         : { type: String , default: 'value'                                 }, // 节点 key

    // 扩展属性
    width       : { type: [Number, String] as PropType<number | string>, default: 250   }, // 宽度
    headClass   : { type: String, default: ''                                           }, // 头部区域类名
    headStyle   : { type: [Object, String] as PropType<StyleValue> , default: ''        }, // 头部区域样式
    mainClass   : { type: String, default: ''                                           }, // 内容区域类名
    mainStyle   : { type: [Object, String] as PropType<StyleValue> , default: ''        }, // 内容区域样式
    footClass   : { type: String, default: ''                                           }, // 底部区域类名
    footStyle   : { type: [Object, String] as PropType<StyleValue> , default: ''        }, // 底部区域样式

    showHead    : { type: Boolean, default: true                                        }, // 是否显示头部
    showFoot    : { type: Boolean, default: false                                       }, // 是否显示底部

    title       : { type: String , default: ''                                          }, // 头部标题
    list        : { type: Array  , default: () => []                                    }, // 列表数据
    prop        : {
        type: Object as PropType<{
            label: string
            value: string
            children: string
            icon: string
        }>,
        default: () => {},
    }, // 自定义列字段
}

export const sdTypeTreeEmits = [
    'check-change',
    'current-change',
    'node-click',
    'node-contextmenu',
    'node-collapse',
    'node-expand',
    'check',
    'node-drag-start',
    'node-drag-end',
    'node-drop',
    'node-drag-leave',
    'node-drag-enter',
    'node-drag-over',
]

export type SdTypeTreeProps    = ExtractPropTypes<typeof sdTypeTreeProps>
export type SdTypeTreeInstance = InstanceType<typeof _TypeTree>
